import { MRT_Row } from "material-react-table";
import type { Job, Deal } from "../../../../../../api/types";
import { ImportTableColumn } from "../../../../../../utilities/types";
import { isFieldRequired, isNumericField, ValidationContext } from "../../../../../../utilities/jobValidation";

/**
 * Check if empty value is valid for the field
 */
export function isValidEmptyValue(
	columnId: ImportTableColumn,
	validationContext: ValidationContext,
	newValue: string,
): boolean {
	return (
		!(isNumericField(columnId) && isFieldRequired(columnId, validationContext)) &&
		!isFieldRequired(columnId, validationContext) &&
		newValue === ""
	);
}

/**
 * Update row._valuesCache for specific fields
 */
export function updateRowCache(row: MRT_Row<Job>, fieldKey: keyof Job, value: any): void {
	if (fieldKey === "branchIds") {
		row._valuesCache.branchIds = value;
	} else if (fieldKey === "externalFrequencyOfMicros") {
		row._valuesCache.externalFrequencyOfMicros = value;
	} else if (fieldKey === "externalTestPackageId") {
		row._valuesCache.labPackage = value;
	} else if (fieldKey === "importDepth") {
		row._valuesCache.importDepth = value;
	} else if (fieldKey === "importDensity") {
		row._valuesCache.importDensity = value;
	}
}

/**
 * Compute dealId using findDeal helper from context
 */
export function computeDealId(
	findDeal: (
		deals: Deal[],
		density: number,
		depth: number,
		labPackage: string,
		micros: number | string,
	) => Deal | undefined,
	allDeals: Deal[],
	job: Job,
): string {
	return (
		findDeal(
			allDeals,
			job.importDensity ?? 0,
			job.importDepth ?? 0,
			job.externalTestPackageId ?? "",
			job.externalFrequencyOfMicros ?? 0,
		)?.id || "custom"
	).toString();
}
